// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__jsz2R","legacyBtn":"MutateMid_legacyBtn__lkN61"};